export default __webpack_public_path__ + "static/media/actualizar.06010713.svg";